var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0769 20.6207C23.0769 21.4863 22.2846 22.5811 20.2748 23.5181C18.3466 24.4171 15.6124 25 12.5385 25C9.46451 25 6.73034 24.4171 4.80208 23.5181C2.79229 22.5811 2 21.4863 2 20.6207C2 19.7551 2.79229 18.6603 4.80208 17.7233C6.73034 16.8243 9.46451 16.2414 12.5385 16.2414C15.6124 16.2414 18.3466 16.8243 20.2748 17.7233C22.2846 18.6603 23.0769 19.7551 23.0769 20.6207Z",
    stroke: "#86868D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4412 25C26 24 29 22.7614 29 20C29 17.2386 26 15 20 14",
    stroke: "#86868D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2729 5.77778C17.2729 8.4715 15.225 10.5556 12.8183 10.5556C10.4116 10.5556 8.36377 8.4715 8.36377 5.77778C8.36377 3.08406 10.4116 1 12.8183 1C15.225 1 17.2729 3.08406 17.2729 5.77778Z",
    stroke: "#86868D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11C21.7614 11 24 8.98528 24 6.5C24 4.01472 21.7614 2 19 2",
    stroke: "#86868D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9997,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.866bc4ef0c9b501ce5a3dacdccced449.svg";
export { ForwardRef as ReactComponent };